'use client'

import Link from 'next/link'
import { usePathname } from 'next/navigation'
import { Ticket02Icon, DropletIcon, Folder01Icon, Exchange01Icon } from '@/utils/icons'

const paths = [
  {
    id: 'swap-page',
    name: 'Swap',
    path: '/',
    logo: <Exchange01Icon className='text-white'/>
  },
  {
    id: 'Pools-page',
    name: 'Pools',
    path: '/pools',
    logo: <DropletIcon />
  },
  // {
  //   id: 'Raffle-page',
  //   name: 'Raffle',
  //   path: '#',
  //   logo: <Ticket02Icon />
  // },
  {
    id: 'Portfolio-page',
    name: 'Portfolio',
    path: '/portfolio',
    logo: <Folder01Icon />
  },
  {
    id: 'Points-page',
    name: 'Points',
    path: '/points',
    logo: <Ticket02Icon />
  }
]

const BottomNavBar: React.FC = () => {
  const pathname = usePathname()

  return (
    <nav className='fixed bottom-0 left-0 right-0 bg-darkPurple border-t border-gray-800 lg:hidden z-50'>
      <ul className='flex justify-around items-center h-16'>
        {paths.map((item, index) => (
          <li key={index} className='flex-1'>
            <Link
              href={item.path}
              className={`flex flex-col items-center justify-center h-full ${
                pathname === item.path ? 'text-primary' : 'text-gray-400'
              }`}
            >
              <span className='text-xl mb-1'>{item.logo}</span>
              <span className='text-xs'>{item.name}</span>
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  )
}

export default BottomNavBar
